<script>
import ApiService from "@/services/jobsiteTrackingService";

export default {
  props: {},
  data() {
    return {
      notification: {
        code: null,
        variant: null,
        messageEN: null,
        messageFR: null,
      },
      notificationClosed: false,
    };
  },
  computed: {
    showNotification: {
      get() {
        return this.notification &&
        this.localizedMessage &&
        this.notification?.code &&
        this.notification?.code !== localStorage.getItem(`lastCodeDissmissed`) &&
        !this.notificationClosed;
      },
      set(value) {
        if (!value) {
          this.notificationClosed = true;
          localStorage.setItem("lastCodeDissmissed", this.notification.code);
        }
      },
    },
    localizedMessage() {
      const lang = this.$i18n.locale;
      return lang === "fr"
        ? this.notification.messageFR
        : this.notification.messageEN;
    },
  },
  created() {
    this.getNotifications();
  },
  methods: {
    getNotifications() {
      ApiService.getNotifications().then((response) => {
        this.notification = response.data;
        const closed =
          localStorage.getItem(
            "lastCodeDissmissed",
          ) === this.notification.code;
        this.notificationClosed = closed;
      });
    },
  },
};
</script>

<template>
  <b-alert
    class="notification-bar m-0"
    :variant="notification.variant"
    :dismissible="true"
    v-model="showNotification"
  >
    <span v-html="localizedMessage"></span>
  </b-alert>
</template>
<style scoped></style>
